class LocalStorageExpires {
  constructor() {
    this.run()
  }

  private run() {
    const toRemove = []
    const currentDate = new Date().getTime()

    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i)
      const item = localStorage.getItem(key)

      if (item && typeof item === 'string' && item.startsWith('{') && item.endsWith('}')) {
        const current = JSON.parse(item)
        if (current.expires && currentDate > current.expires) {
          toRemove.push(key)
        }
      }
    }

    toRemove.forEach(key => {
      localStorage.removeItem(key)
    })
  }

  set(key: string, value: unknown, expiresInMin: number) {
    const expires = new Date().getTime() + expiresInMin * 60 * 1000

    localStorage.setItem(
      key,
      JSON.stringify({
        value,
        expires,
      })
    )
  }

  get(key: string) {
    this.run()

    const item = localStorage.getItem(key)

    if (item && typeof item === 'string' && item.startsWith('{') && item.endsWith('}')) {
      const { value, expires } = JSON.parse(item)

      if (expires && new Date().getTime() < expires) {
        return value
      }
    }

    return null
  }
}

const localStorageExpires = new LocalStorageExpires()

export { localStorageExpires }
